import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import ScrollToTop from '../components/ScrollTop';

const HowItWorks = () => {

    const steps = [
        {
            stepNum: 1,
            stepTitle: 'Online Registration',
            stepDescription: 'Create your account and set up your profile on the MindMetric platform.',
            icon: '1'
        },
        {
            stepNum: 2,
            stepTitle: 'Answer Assessment Questions',
            stepDescription: 'Complete behavior-based and situational questions designed by experts.',
            icon: '2'
        },
        {
            stepNum: 3,
            stepTitle: 'Get Intelligence Report',
            stepDescription: 'Receive detailed intelligence profile, career guidance, and personalized insights.',
            icon: '3'
        }
    ];

    return (
        <body className="how-it-works-page">
            <Header parentMenu='how-it-works' />

            <div className="react-wrapper">
                <div className="react-wrapper-inner">
                    <Breadcrumb pageTitle="How It Works" />

                    <div className="how-it-works-section pt---100 pb---100">
                        <div className="container">
                            <div className="react__title__section react__title__section-all text-center mb---50">
                                <h6 className="wow animate__fadeInUp" data-wow-duration="0.3s">Assessment Process</h6>
                                <h2 className="react__tittle wow animate__fadeInUp" data-wow-duration="0.5s">
                                    How Multiple Intelligence Works<br/>Discover Your Unique Intelligence Profile
                                </h2>
                            </div>

                            <div className="row pt---30">
                                {steps.map((step, index) => (
                                    <div key={index} className="col-md-4 wow animate__fadeInUp" data-wow-duration={`${0.3 + (index * 0.2)}s`}>
                                        <div className="step-card" style={{
                                            padding: '30px',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            textAlign: 'center',
                                            transition: 'all 0.3s ease',
                                            backgroundColor: '#f9f9f9'
                                        }}>
                                            <div className="step-number" style={{
                                                fontSize: '48px',
                                                fontWeight: 'bold',
                                                color: '#007bff',
                                                marginBottom: '20px'
                                            }}>
                                                Step {step.stepNum}
                                            </div>
                                            <h3 style={{
                                                fontSize: '20px',
                                                fontWeight: '600',
                                                marginBottom: '15px',
                                                color: '#333'
                                            }}>
                                                {step.stepTitle}
                                            </h3>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                marginBottom: '20px'
                                            }}>
                                                {step.stepDescription}
                                            </p>
                                            <a href="/signup" style={{
                                                color: '#007bff',
                                                textDecoration: 'none',
                                                fontWeight: '600'
                                            }}>
                                                Get Started
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-right" style={{display: 'inline-block', marginLeft: '8px'}}>
                                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                                    <polyline points="12 5 19 12 12 19"></polyline>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="text-center mt---50">
                                <p style={{fontSize: '16px', color: '#666'}}>Ready to test your skills?</p>
                                <a href="/signup" className="btn btn-primary" style={{
                                    padding: '12px 30px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    textDecoration: 'none',
                                    borderRadius: '4px',
                                    display: 'inline-block',
                                    marginTop: '15px'
                                }}>
                                    Create Free Account
                                </a>
                            </div>
                        </div>
                    </div>

                    <ScrollToTop />
                </div>
            </div>

            <Footer />
        </body>
    );
}

export default HowItWorks;
